import {
    Center,
    Group,
    Text
} from "@mantine/core";

import {Link} from "react-router-dom";

// REGISTRATION-PAUSE (FNP-1222) — TEMPORARY: remove this import and the guard
// below to restore the link. See src/config/registration.ts.
import {isRegistrationEnabled} from "../../../../config/registration";

export const LinkToSignUpPage = () => {

    // REGISTRATION-PAUSE (FNP-1222): hides the prompt at all five render sites
    // (sign-in index/select/confirm, reset-password index/confirm).
    if (!isRegistrationEnabled()) {
        return null;
    }

    return (
        <Center>
            <Group>
                <Text>Don't have an account?</Text>
                <Link to={'/sign-up'}>Sign Up</Link>
            </Group>
        </Center>
    );

}
